import type { ListBuilderList } from '../../../types';
import { createClientColumnsNoLifecycle } from '../columns';
import {
	CLIENT_MOBILE_CARD_CONFIG,
	DEFAULT_LIST_REQUIRED_FIELDS,
	createClientKanbanConfig,
} from '../shared';

/**
 * Open Orders list configuration
 * Clients with open orders
 */
export const defaultClientsOpenOrdersList: ListBuilderList = {
	id: 'default-clients-open-orders',
	cacheTTL: 600000,
	name: 'Open Orders',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	filterRules: {
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
					applyAsDefault: false,
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
					applyAsDefault: false,
				},
			],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
		orderSalesStatus: {
			defaultValue: [
				{
					id: 'open-orders',
					label: 'Open Orders',
				},
			],
		},
	},
	columns: createClientColumnsNoLifecycle(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description: 'Clients with open orders',
	defaultSortId: 'column-client-name-asc',
	requiredFields: DEFAULT_LIST_REQUIRED_FIELDS,
	sortOrder: 6,
	kanbanConfig: createClientKanbanConfig(),
};
